/*
 * Copyright (c) 2014-2023 Inovalon, Inc. All Rights Reserved.
 * This computer program is CONFIDENTIAL and a TRADE SECRET of Inovalon, Inc.
 * The receipt or possession of this program does not convey any rights to use, reproduce or disclose
 * its contents in whole or in part, without the specific written consent of Inovalon, Inc.
 * Any use, reproduction or disclosure of this program without the express written consent of Inovalon, Inc.
 * is a violation of the copyright laws and may subject you to criminal prosecution.
 */
import 'reflect-metadata'
import { injectable } from 'inversify'
import { ICoverageDiscoveryRequestApiClient } from './contracts'
import { ICoverageDiscoveryRequestDetail, IStates, ICoverageDiscoveryAccountFacilities, ICoverageDiscoveryResponse } from '../CoverageDiscoveryRequestStateManager/contracts'

@injectable()
export class MockCoverageDiscoveryRequestApiClient implements ICoverageDiscoveryRequestApiClient {
	public allItems: ICoverageDiscoveryRequestDetail[] = []
	private firstNames = ['John', 'Betty', 'Alice', 'Peter']
	private lastNames = ['Smith', 'Doe', 'Roberts']

	constructor() {
		for (let x = 1; x < 100; x++) {
			const fName = this.firstNames[Math.ceil((Math.random() * this.firstNames.length) % this.firstNames.length) - 1]
			const lName = this.lastNames[Math.ceil((Math.random() * this.lastNames.length) % this.lastNames.length) - 1]
			const dob = new Date(1970, 1, Math.round((Math.random() * 10000) % 10000))
			const ssn = this.generateRandomNumberString(9)
			const zip = this.generateRandomNumberString(5)
			const homePhone = this.generateRandomNumberString(10)
			this.allItems.push({
				id: x,
				customerEntityFacilityId: 1,
				RequestedByUserId: null,
				serviceBeginDate: new Date().toDateString(),
				serviceEndDate: new Date().toDateString(),
				individualLastName: lName,
				individualMiddleName: null,
				individualFirstName: fName,
				individualAddress1: 'Test Address',
				individualAddress2: null,
				individualCity: 'TestCity',
				individualStateCodeId: 1,
				individualZip: zip,
				individualGender: null,
				individualSocialSecurityNumber: ssn,
				individualDateOfBirth: dob.toDateString(),
				individualPhoneNumber: homePhone,
				guarantorLastName: null,
				guarantorMiddleName: null,
				guarantorFirstName: null,
				guarantorGender: null,
				guarantorDateOfBirth: null,
				guarantorSocialSecurityNumber: null,
				guarantorAddress1: null,
				guarantorAddress2: null,
				guarantorCity: null,
				guarantorStateCodeId: null,
				guarantorZip: null,
				guarantorPhoneNumber: null,
			})
		}
	}

	generateRandomNumberString(length: number): string {
		let result = ''
		const characters = '0123456789'
		const charactersLength = characters.length
		for (let i = 0; i < length; i++) {
			result += characters.charAt(Math.floor(Math.random() * charactersLength))
		}
		return result
	}
	getRandomArbitrary(min: number, max: number) {
		return Math.random() * (max - min) + min
	}

	saveRequestDetail(RequestDetail: ICoverageDiscoveryRequestDetail): Promise<ICoverageDiscoveryResponse> {
		return new Promise<ICoverageDiscoveryResponse>(resolve => {
			resolve({
				id: Number((Math.random() * 100).toFixed(0)),
			})
		})
	}

	getAllFacilities(): Promise<ICoverageDiscoveryAccountFacilities[]> {
		return new Promise<ICoverageDiscoveryAccountFacilities[]>(resolve =>
			resolve([
				{
					id: 1,
					facilityName: 'Facility1',
					customerEntityId: 1,
					customerEntityFacilityStatusId: 1,
					active: true,
					npi: '',
					primaryPin: '',
					federalTaxId: '',
				},
				{
					id: 2,
					facilityName: 'Facility2',
					customerEntityId: 1,
					customerEntityFacilityStatusId: 1,
					active: true,
					npi: '',
					primaryPin: '',
					federalTaxId: '',
				},
				{
					id: 3,
					facilityName: 'Facility3',
					customerEntityId: 1,
					customerEntityFacilityStatusId: 1,
					active: true,
					npi: '',
					primaryPin: '',
					federalTaxId: '',
				},
			]),
		)
	}

	getAllStates(): Promise<IStates[]> {
		return new Promise<IStates[]>(resolve =>
			resolve([
				{ id: 1, name: 'Alabama' },
				{ id: 2, name: 'Alaska' },
				{ id: 3, name: 'Arizona' },
				{ id: 4, name: 'Arkansas' },
				{ id: 5, name: 'California' },
				{ id: 6, name: 'Colorado' },
				{ id: 7, name: 'Connecticut' },
				{ id: 8, name: 'Delaware' },
				{ id: 9, name: 'Florida' },
				{ id: 10, name: 'Georgia' },
				{ id: 11, name: 'Hawaii' },
				{ id: 12, name: 'Idaho' },
				{ id: 13, name: 'Illinois' },
				{ id: 14, name: 'Indiana' },
				{ id: 15, name: 'Iowa' },
				{ id: 16, name: 'Kansas' },
				{ id: 17, name: 'Kentucky[E]' },
				{ id: 18, name: 'Louisiana' },
				{ id: 19, name: 'Maine' },
				{ id: 20, name: 'Maryland' },
				{ id: 21, name: 'Massachusetts[E]' },
				{ id: 22, name: 'Michigan' },
				{ id: 23, name: 'Minnesota' },
				{ id: 24, name: 'Mississippi' },
				{ id: 25, name: 'Missouri' },
				{ id: 26, name: 'Montana' },
				{ id: 27, name: 'Nebraska' },
				{ id: 28, name: 'Nevada' },
				{ id: 29, name: 'New Hampshire' },
				{ id: 30, name: 'New Jersey' },
				{ id: 31, name: 'New Mexico' },
				{ id: 32, name: 'New York' },
				{ id: 33, name: 'North Carolina' },
				{ id: 34, name: 'North Dakota' },
				{ id: 35, name: 'Ohio' },
				{ id: 36, name: 'Oklahoma' },
				{ id: 37, name: 'Oregon' },
				{ id: 38, name: 'Pennsylvania[E]' },
				{ id: 39, name: 'Rhode Island[F]' },
				{ id: 40, name: 'South Carolina' },
				{ id: 41, name: 'South Dakota' },
				{ id: 42, name: 'Tennessee' },
				{ id: 43, name: 'Texas' },
				{ id: 44, name: 'Utah' },
				{ id: 45, name: 'Vermont' },
				{ id: 46, name: 'Virginia[E]' },
				{ id: 47, name: 'Washington' },
				{ id: 48, name: 'West Virginia' },
				{ id: 49, name: 'Wisconsin' },
				{ id: 50, name: 'Wyoming' },
				{ id: 51, name: 'Alabama' },
				{ id: 52, name: 'Alaska' },
				{ id: 53, name: 'Arizona' },
				{ id: 54, name: 'Arkansas' },
				{ id: 55, name: 'California' },
				{ id: 56, name: 'Colorado' },
				{ id: 57, name: 'Connecticut' },
				{ id: 58, name: 'Delaware' },
				{ id: 59, name: 'Florida' },
				{ id: 60, name: 'Georgia' },
				{ id: 61, name: 'Hawaii' },
				{ id: 62, name: 'Idaho' },
				{ id: 63, name: 'Illinois' },
				{ id: 64, name: 'Indiana' },
				{ id: 65, name: 'Iowa' },
				{ id: 66, name: 'Kansas' },
				{ id: 67, name: 'Kentucky[E]' },
				{ id: 68, name: 'Louisiana' },
				{ id: 69, name: 'Maine' },
				{ id: 70, name: 'Maryland' },
				{ id: 71, name: 'Massachusetts[E]' },
				{ id: 72, name: 'Michigan' },
				{ id: 73, name: 'Minnesota' },
				{ id: 74, name: 'Mississippi' },
				{ id: 75, name: 'Missouri' },
				{ id: 76, name: 'Montana' },
				{ id: 77, name: 'Nebraska' },
				{ id: 78, name: 'Nevada' },
				{ id: 79, name: 'New Hampshire' },
				{ id: 80, name: 'New Jersey' },
				{ id: 81, name: 'New Mexico' },
				{ id: 82, name: 'New York' },
				{ id: 83, name: 'North Carolina' },
				{ id: 84, name: 'North Dakota' },
				{ id: 85, name: 'Ohio' },
				{ id: 86, name: 'Oklahoma' },
				{ id: 87, name: 'Oregon' },
				{ id: 88, name: 'Pennsylvania[E]' },
				{ id: 89, name: 'Rhode Island[F]' },
				{ id: 90, name: 'South Carolina' },
				{ id: 91, name: 'South Dakota' },
				{ id: 92, name: 'Tennessee' },
				{ id: 93, name: 'Texas' },
				{ id: 94, name: 'Utah' },
				{ id: 95, name: 'Vermont' },
				{ id: 96, name: 'Virginia[E]' },
				{ id: 97, name: 'Washington' },
				{ id: 98, name: 'West Virginia' },
				{ id: 99, name: 'Wisconsin' },
				{ id: 100, name: 'Wyoming' },
			]),
		)
	}

	getCoverageDiscoveryTransactionStatusId(id: number): Promise<boolean> {
		return new Promise<boolean>(resolve => {
			resolve(true)
		})
	}

	updateCDStatusTimeout(id: number): Promise<boolean> {
		return new Promise<boolean>(resolve => {
			resolve(true)
		})
	}

	getRequestDetail(id: number): Promise<ICoverageDiscoveryRequestDetail> {
		return new Promise<ICoverageDiscoveryRequestDetail>(resolve => {
			resolve({
				id: 0,
				customerEntityFacilityId: 0,
				RequestedByUserId: null,
				serviceBeginDate: new Date().toDateString(),
				serviceEndDate: new Date().toDateString(),
				individualLastName: '',
				individualMiddleName: '',
				individualFirstName: 'IFN1',
				individualGender: '',
				individualDateOfBirth: null,
				individualSocialSecurityNumber: null,
				individualAddress1: null,
				individualAddress2: null,
				individualCity: null,
				individualStateCodeId: null,
				individualZip: null,
				individualPhoneNumber: null,
				guarantorLastName: null,
				guarantorMiddleName: null,
				guarantorFirstName: 'GFN1',
				guarantorGender: null,
				guarantorDateOfBirth: null,
				guarantorSocialSecurityNumber: null,
				guarantorAddress1: null,
				guarantorAddress2: null,
				guarantorCity: null,
				guarantorStateCodeId: null,
				guarantorZip: null,
				guarantorPhoneNumber: null,
			})
		})
	}
}
